export default __webpack_public_path__ + "static/media/orderReportIcon.797a133a.svg";